import { welcomePageName } from 'components/PrePurchaseSurvey/SurveyData'
import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  :root {
    --file-upload-image-src: '';
  }

  @font-face {
    font-family: 'Mabry Pro';
    font-style: normal;
    font-weight: normal;
    src: url("/static/mabry-regular-pro.ttf") format("opentype");
  }

  @font-face {
    font-family: 'Mabry Pro';
    font-style: normal;
    font-weight: 200;
    src: url("/static/mabry-light-pro.ttf") format("opentype");
  }

  @font-face {
    font-family: 'Mabry Pro';
    font-style: normal;
    font-weight: bold;
    src: url("/static/mabry-bold-pro.ttf") format("opentype");
  }

  @font-face {
    font-family: 'JJannon';
    font-weight: normal;
    font-style: normal;
    font-weight: 400;
    src: url("/static/JJannon-Book.otf") format("opentype");
  }

  @font-face {
    font-family: 'JJannon';
    font-weight: normal;
    font-weight: 400;
    font-style: italic;
    src: url("/static/JJannon-BookItalic.otf") format("opentype");
  }

  @font-face {
    font-family: 'Greycliff CF';
    font-weight: 200;
    src: url("/static/GreycliffCF-Light.otf") format("opentype");
  }

  @font-face {
    font-family: 'Greycliff CF';
    font-weight: normal;
    font-weight: 400;
    src: url("/static/GreycliffCF-Regular.otf") format("opentype");
  }
  @font-face {
    font-family: 'Greycliff CF';
    font-weight: bold;
    font-weight: 700;
    src: url("/static/GreycliffCF-DemiBold.otf") format("opentype");
  }
  @font-face {
    font-family: 'Quincy CF';
    font-weight: 100;
    src: url("/static/QuincyCF-Thin.otf") format("opentype");
  }
  @font-face {
    font-family: 'Quincy CF';
    font-weight: 100;
    font-style: italic;
    src: url("/static/QuincyCF-Thin-Italic.otf") format("opentype");
  }
  @font-face {
    font-family: 'Quincy CF';
    font-weight: 200;
    src: url("/static/QuincyCF-Light.otf") format("opentype");
  }
  @font-face {
    font-family: 'Quincy CF';
    font-weight: 400;
    src: url("/static/QuincyCF-Regular.otf") format("opentype");
  }
  @font-face {
    font-family: 'Quincy CF';
    font-weight: bold;
    font-weight: 700;
    font-style: italic;
    src: url("/static/QuincyCF-Bold-Italic.otf") format("opentype");
  }

  @font-face {
    font-family: 'MetaSerifPro-Medium';
    src: url("/static/meta-serif-pro--medium.woff2") format("woff2"),
         url("/static/meta-serif-pro--medium.woff") format("woff"),
         url("/static/meta-serif-pro--medium.otf") format("opentype");
  }

  @font-face {
    font-family: 'MaisonNeue-Medium';
    src: url("/static/maison-neue--medium.woff2") format("woff2"),
         url("/static/maison-neue--medium.woff") format("woff"),
         url("/static/maison-neue--medium.otf") format("opentype");
  }

  @font-face {
    font-family: 'DM Sans';
    src: url("/static/DMSans-Regular.ttf") format("opentype");
    font-weight: 400;
  }

  @font-face {
    font-family: 'DM Sans';
    src: url("/static/DMSans-Italic.ttf") format("opentype");
    font-weight: 400;
    font-style: italic;
  }

  @font-face {
    font-family: 'DM Sans';
    src: url("/static/DMSans-Bold.ttf") format("opentype");
    font-weight: bold;
  }

  @font-face {
    font-family: 'DM Mono';
    src: url("/static/DMMono-Regular.ttf") format("opentype");
    font-weight: 400;
  }

  @font-face {
    font-family: 'DM Mono';
    src: url("/static/DMMono-Bold.ttf") format("opentype");
    font-weight: bold;
  }

  @font-face {
    font-family: 'Inter';
    src: url("/static/Inter-Regular.ttf") format("opentype");
    font-weight: 400;
  }

  @font-face {
    font-family: 'Inter';
    src: url("/static/Inter-Bold.ttf") format("opentype");
    font-weight: bold;
  }


  @font-face {
    font-family: 'IBM Plex Serif';
    src: url("/static/IBMPlexSerif-Italic.ttf") format("opentype");
    font-weight: 400;
  }

  #surveyElement {
    display: flex;
    flex-direction: column;
  }

  #surveyElement > svg {
    align-self: center;
  }

  * {
    text-align: center;
  }

  body {
    font-family: 'Greycliff CF';
    margin: 0;

    &.base-page {
      background-color: ${props => props.theme.colors.darkGreen};
      color: ${props => props.theme.colors.white};

      .thinker-phrase p {
        color: ${props => props.theme.colors.white};
      }
    }

    &.white-page {
      background-color: ${props => props.theme.colors.white};
      color: ${props => props.theme.colors.black};

      div, p {
        color: inherit;
      }

      .disable-next-button {
        .sv-footer__next-btn, .sv-footer__complete-btn {
          background-color: ${props => props.theme.colors.seeShell};
          color: ${props => props.theme.colors.silverMist};
          cursor: default;
          pointer-events: none;
        }
      }

      .sv-footer__next-btn, .sv-footer__complete-btn {
        background-color: ${props => props.theme.colors.black};
        color: ${props => props.theme.colors.white};
        border-radius: 80px;
        width: 100%;
        font-family: Greycliff CF;
        line-height: 24px;
        font-weight: 600;
        letter-spacing: 0.18px;
        text-transform: capitalize;
        padding: 18px 0 20px 0;

        &:disabled {
          background-color: ${props => props.theme.colors.seeShell};
          color: ${props => props.theme.colors.silverMist};
        }

        @media (max-width: ${props => props.theme.breakpoints.mobile}) {
          padding: 11px 0 13px 0;
        }
      }

      .thinker-phrase p {
        color: ${props => props.theme.colors.obsidianBlack};
      }
    }

    &.green-page {
      background-color: ${props => props.theme.colors.forestMoss};

      & .layout-header--onboarding svg path {
        fill: ${props => props.theme.colors.white};

        @media (max-width: ${props => props.theme.breakpoints.desktop}) {
          fill: ${props => props.theme.colors.obsidianBlack};
        }
      }

      .sv-footer__next-btn {
        background-color: ${props => props.theme.colors.white};
        color: ${props => props.theme.colors.heavyMetal};
        border-radius: 80px;
        width: 100%;
        font-family: Greycliff CF;
        line-height: 24px;
        font-weight: 600;
        letter-spacing: 0.18px;
        text-transform: capitalize;
        padding: 19px 0 21px 0;

        @media (max-width: ${props => props.theme.breakpoints.mobile}) {
          padding: 11px 0 13px 0;
        }
      }

      .ppq-interstitial p {
        color: ${props => props.theme.colors.white};
      }

      .ppq-interstitial a {
        color: inherit;
      }
    }

    &.onboarding-interstitial-page {
      text-align: center;
      font-family: Greycliff CF;
      font-style: normal;

      .survey-container {
        min-height: calc(100vh - 80px);
        @media (max-width: ${props => props.theme.breakpoints.desktop}) {
          min-height: 100vh;
        }
      }

      .layout-header--onboarding {
        background-color: ${props => props.theme.colors.white};
      }

      .sv-page {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
      }
    }

    &.peachy-page {
      .survey-container {
        background-color: ${props => props.theme.colors.peachy};
      }
    }

    &.lavender-page {
      .survey-container {
        background-color: ${props => props.theme.colors.lavender};
      }
    }
  }

  h5.sv-title span:first-child {
    font-family: 'Greycliff CF';
    font-style: normal;
    font-weight: 500;
    font-size: 26px;
    line-height: 32px;

    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
      font-size: 30px;
      line-height: 36px;
    }
  }

  p {
    font-family: 'Greycliff CF';
    color: ${props => props.theme.colors.white};
    font-size: 20px;
  }

  a {
    color: ${props => props.theme.colors.yellowBright};
  }

  span {
    font-family: 'Greycliff CF';
  }

  div {
   font-family: 'Greycliff CF';
   color: ${props => props.theme.colors.white};
  }

  input {
    font-family: 'Mabry Pro';
    font-size: 18px;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .sv-multipletext .sv-multipletext__cell div.sv-question__erbox {
    padding: 25px 30px;
    max-width: 300px;
    margin-top: 0;
  }

  .sv-multipletext__row .sv-multipletext__cell:nth-child(2) {
    display: flex;
    flex-direction: column;
  }

  .hidden {
    display: none !important;
  }

  .no-margin {
    margin: 0;
  }

  .text-left {
    text-align: left;
  }

  .paragraph-small-fs {
    font-size: 14px;
  }

  .d-flex {
    display: flex;
  }

  .align-center {
    align-items: center;
  }

  .mobile-meds-and-interaction {
    display: none;
    width: auto;
    max-height: 200px;

    @media (max-width: ${props => props.theme.breakpoints.desktop}) {
        display: block;
    }
  }

  // Dropdown styles

  .sv-dropdown {
    width: 300px;
    height: 64px;
    padding: 0 16px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #0e0e0f;
    border: 1px solid #a2a9a9;
    border-radius: 8px;
    background-image: url('/drop-down-arrow.svg') !important;
    cursor: pointer;

    @media (min-width: ${props => props.theme.breakpoints.md}) {
      width: 335px !important;
    }
  }

  .sv-dropdown__native {
    text-align-last: left;
  }

  .sv-popup__container {
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
    position: absolute;
    padding: 0;
  }

  .sv-dropdown_clean-button {
    display: none;
  }

  .sv-dropdown__filter-string-input::placeholder {
    text-align: left;
  }

  .sv-dropdown__value {
    text-overflow: clip;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    flex-wrap: wrap;
  }

  .sv-list__item--selected {
    background-color: #9f9f9f !important;
    .sv-list__item-body {
      background-color: #9f9f9f !important;
    }
  }
  .sv-popup__scrolling-content *::-webkit-scrollbar,
  .sv-popup__scrolling-content::-webkit-scrollbar-thumb,
  .sv-popup__scrolling-content *::-webkit-scrollbar-thumb {
    display: none !important;
  }

  .try-another-group-id-button,
  .skip-group-id-button {
    margin-top: 12px;
    min-width: 100%;
    .sv-btn {
      border-radius: 80px;
      height: 62px;
      text-align: center;
      font-family: Greycliff CF !important;
      font-size: 18px !important;
      font-style: normal !important;
      font-weight: 600 !important;
      line-height: 24px !important;
      letter-spacing: 0.18px !important;
      width: 100%;
      margin: 0;
      text-transform: none !important;
      @media (max-width: ${props => props.theme.breakpoints.mobile}) {
        height: 48px;
      }
    }
    &--hidden {
      display: none;
    }
  }

  .survey-layout[name='about-insurance'] .sv-action-bar {
    display: flex;
    flex-direction: column;

    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
      padding-right: 20px;
      padding-left: 20px;
    }
  }

  .sv-action {
    width: 100%;
  }

  .survey-layout[name='about-insurance'] .sv-body {
    padding: unset;
  }

  .state-select-dropdown {
    .sv-list__filter {
      display: none !important;
    }

    .sv-popup__body-footer {
      display: none !important;
    }

    .sv-popup__container {
      width: 300px !important;
      height: 300px !important;
      margin: auto;
      top: 0 !important;
      right: 0;
      left: 0;
      border-radius: 8px;

      @media (min-width: 768px) {
        width: 335px !important;
        height: 50vh !important;
      }
    }
  }

  .insurance-details-dropdown {
    .sv-list__filter {
      display: none !important;
    }

    .sv-popup__body-footer {
      display: none !important;
    }

    .sv-popup__container {
      width: 300px;
      height: 160px;
      margin: auto;
      top: 0 !important;
      left: 0;
      right: 0;
      border-radius: 8px;

      @media (min-width: 768px) {
        width: 335px !important;
      }

      @media (max-height: 670px) {
        height: 120px;
      }
    }
  }

  .insurance-pages-footer-mobile {
      padding-bottom: 5px !important;
  }

  .sv-boolean {
    margin-top: 25px;
    margin-left: -15px;

    label {
      display: flex;
      align-items: end;
    }
  }

  .sv-boolean__label {
    font-size: 14px;
    float: right;
    margin-left: 10px;
    font-family: Greycliff CF;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0;

    @media (min-width: ${props => props.theme.breakpoints.sm}) {
      font-size: 16px;
      margin-left: 12px;
    }
  }

  .sv-boolean--checked {
    .sv-item__decorator {
      border: 1px solid ${props => props.theme.colors.obsidianBlack};
    }
  }

  .sv-item__decorator {
    width: 24px;
    height: 24px;
    border: 1px solid ${props => props.theme.colors.greyChateau};
    cursor: pointer;
  }

  .sv-boolean--checked {
    .custom-checkbox {
      ::before {
        content: url('/covered-insurance-true-checkbox.svg');
        position: relative;
      }
    }
  }

  .survey-layout[name='${welcomePageName}'] {
    padding-top: 0;

    .sv-body {
      max-width: unset;
      padding: 0;
    }

    .sv-action-bar {
      display: none;
    }
  }
`

export default GlobalStyle
